(function () {
  /* Freeze hero header overlap once — avoids scroll jank from live header height updates */
  function freezeHeroHeaderOverlap() {
    const headerGroup = document.getElementById('header-group');
    if (!headerGroup) return;
    document.documentElement.style.setProperty(
      '--desire-hero-header-overlap',
      `${Math.round(headerGroup.offsetHeight)}px`
    );
  }

  freezeHeroHeaderOverlap();
  let heroOverlapTimer;
  window.addEventListener(
    'resize',
    () => {
      clearTimeout(heroOverlapTimer);
      heroOverlapTimer = setTimeout(freezeHeroHeaderOverlap, 200);
    },
    { passive: true }
  );

  if (!document.body.classList.contains('template-index')) return;

  if (window.location.hash === '#faq') {
    const faq = document.getElementById('faq');
    if (faq) {
      window.requestAnimationFrame(() => {
        faq.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  /* Scroll reveal */
  const animateEls = document.querySelectorAll('.desire-animate:not(.desire-hero):not(.desire-hero *)');
  if (animateEls.length && 'IntersectionObserver' in window) {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -30px 0px' }
    );
    animateEls.forEach((el) => obs.observe(el));
  } else {
    animateEls.forEach((el) => el.classList.add('is-visible'));
  }

  /* Testimonials carousel — 3 visible desktop (reference), 2 tablet, 1 mobile */
  document.querySelectorAll('[data-desire-carousel]').forEach((root) => {
    const viewport = root.querySelector('.desire-testimonials__viewport');
    const track = root.querySelector('[data-carousel-track]');
    const slides = [...root.querySelectorAll('[data-carousel-slide]')];
    const dots = [...root.parentElement.querySelectorAll('[data-carousel-dot]')];
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    if (!track || !viewport || slides.length < 1) return;

    const gap = 16;
    let index = 0;
    let touchStartX = 0;

    function perView() {
      if (window.innerWidth < 750) return 1;
      if (window.innerWidth < 990) return 2;
      return 3;
    }

    function maxIndex() {
      return Math.max(0, slides.length - perView());
    }

    function slideStep() {
      const slide = slides[0];
      if (!slide) return 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function goTo(i) {
      const max = maxIndex();
      if (i < 0) index = max;
      else if (i > max) index = 0;
      else index = i;
      track.style.transform = `translate3d(-${index * slideStep()}px, 0, 0)`;
      slides.forEach((s, j) => s.classList.toggle('is-active', j >= index && j < index + perView()));
      dots.forEach((d, j) => d.classList.toggle('is-active', j === index));
    }

    prev?.addEventListener('click', () => goTo(index - 1));
    next?.addEventListener('click', () => goTo(index + 1));
    dots.forEach((d) =>
      d.addEventListener('click', () => goTo(parseInt(d.dataset.carouselDot, 10)))
    );

    viewport.addEventListener(
      'touchstart',
      (e) => {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );
    viewport.addEventListener(
      'touchend',
      (e) => {
        const delta = e.changedTouches[0].screenX - touchStartX;
        if (Math.abs(delta) < 40) return;
        goTo(delta < 0 ? index + 1 : index - 1);
      },
      { passive: true }
    );

    goTo(0);
    window.addEventListener('resize', () => goTo(Math.min(index, maxIndex())));
  });
})();
